import React, {ReactNode} from "react";

import {LeftPanelClose} from "../icons/LeftPanelClose";
import {LeftPanelOpen} from "../icons/LeftPanelOpen";
import {Tooltip} from "../Tooltip";

import "./MainSidebarHeader.css";

export interface MainSidebarHeaderProps {
    isCollapsed: boolean;
    workspaceSelect: ReactNode;
    workspaceAvatar?: ReactNode;
    collapseLabel: string;
    expandLabel: string;
    onCollapse: () => void;
    onExpand: () => void;
}

export const MainSidebarHeader = ({
    isCollapsed,
    workspaceSelect,
    workspaceAvatar,
    collapseLabel,
    expandLabel,
    onCollapse,
    onExpand,
}: MainSidebarHeaderProps) => {
    return (
        <div className="MainSidebar__workspace">
            {!isCollapsed ? (
                <>
                    {workspaceSelect}
                    <Tooltip title={collapseLabel}>
                        <LeftPanelClose
                            className="MainSidebar__collapseToggle"
                            aria-label={collapseLabel}
                            onClick={onCollapse}
                            additionalPadding={2}
                        />
                    </Tooltip>
                </>
            ) : (
                <button
                    type="button"
                    className="MainSidebar__wsCollapsed"
                    onClick={onExpand}
                    aria-label={expandLabel}
                >
                    {workspaceAvatar}
                    <LeftPanelOpen size={24} additionalPadding={4} className="MainSidebar__wsOpenIcon"/>
                </button>
            )}
        </div>
    );
};
